module.exports = __webpack_public_path__ + "img/partner.a13a2801.svg";